import React from 'react';

import { useViewport } from 'contexts/viewport';
import withResponsiveLayout from 'hoc/withResponsive';
import Mobile from 'pages/CourseSetUp/mobile';
import Tablet from 'pages/CourseSetUp/tablet';
import Desktop from 'pages/CourseSetUp/desktop';
import { useUser2 } from 'contexts/user2';
import { LogoLoading } from 'ensightful-koala-ui';

const PageLayout = () => {
    const { width } = useViewport();
    const { isLoading } = useUser2();

    const responsiveLayouts = {
        mobile: <Mobile />,
        tablet: <Tablet />,
        desktop: <Desktop />,
    };

    return isLoading ? <LogoLoading /> : withResponsiveLayout(width, responsiveLayouts);
};

export default PageLayout;
